import React, { useContext, createContext } from 'react';
import { Map } from 'azure-maps-control';
import { MapTypes } from './MapThemeProvider';

interface TrackingMapContextValue {
    isFullScreen: boolean;
    setIsFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
    mapType: MapTypes | null;
    setMapType: React.Dispatch<React.SetStateAction<MapTypes>>;
    isTrafficEnabled: boolean;
    isWeatherEnabled: boolean;
    isDisruptionsEnabled: boolean;
    setIsTrafficEnabled(isTrafficEnabled: boolean): void;
    setIsWeatherEnabled(isWeatherEnabled: boolean): void;
    setIsDisruptionsEnabled(isDisruptionsEnabled: boolean): void;
    map: Map | null;
}

const TrackingMapContext = createContext<TrackingMapContextValue>({
    isFullScreen: false,
    isDisruptionsEnabled: true,
    isTrafficEnabled: false,
    isWeatherEnabled: false,
    map: null,
    setIsDisruptionsEnabled: () => { },
    setIsFullScreen: () => { },
    setIsTrafficEnabled: () => { },
    setIsWeatherEnabled: () => { },
    setMapType: () => { },
    mapType: null
});

export const TrackingMapProvider = TrackingMapContext.Provider;

export function useTrackingMap() {
    return useContext(TrackingMapContext);
}
